import { create } from "zustand";

export const useNotificationsCount = create((set) => ({
  notificationsCount: 0,
  addNotificationsCount: (data: any) =>
    set(() => ({ notificationsCount: data })),
}));
